"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Edit = function Edit(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className, " ").concat(animation)
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.536 16.56H6.048a2.82 2.82 0 01-2.816-2.816V6.256A2.82 2.82 0 016.048 3.44h4.188a.625.625 0 010 1.248H6.048A1.57 1.57 0 004.48 6.256v7.488a1.57 1.57 0 001.568 1.568h7.488a1.57 1.57 0 001.568-1.568V10a.625.625 0 011.248 0v3.744a2.82 2.82 0 01-2.816 2.816z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.073 11.728a.634.634 0 01-.428-.168.631.631 0 01-.192-.544l.384-2.668a.634.634 0 01.18-.356l3.844-3.764c.864-.916 2.34-.964 3.276-.084.808.76.848 2.04.088 2.848L12.15 11a.612.612 0 01-.312.168l-2.636.548a.662.662 0 01-.128.012zm2.64-1.172h.012-.012zm-1.668-1.82l-.228 1.576 1.584-.328L15.33 6.12c.272-.288.256-.776-.052-1.064a1.081 1.081 0 00-1.528.048l-3.704 3.632z",
    fill: color
  }));
};
var _default = exports["default"] = Edit;